import { supabase } from './supabaseClient'
import type { User } from '@supabase/supabase-js'

export interface AuthState {
  user: User | null
  loading: boolean
}

// Simple email/password authentication
export const signUp = async (email: string, password: string) => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      emailRedirectTo: window.location.origin + '/home'
    }
  })
  
  if (error) throw error
  return data
}

export const signIn = async (email: string, password: string) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  })
  
  if (error) throw error
  return data
}

export const signOut = async () => {
  try {
    console.log('Attempting to sign out...')
    const { error } = await supabase.auth.signOut()
    if (error) {
      console.error('Error in supabase.auth.signOut():', error)
      throw error
    }
    console.log("Sign out successful from auth.ts")
    return true
  } catch (error) {
    console.error('Error in signOut function:', error)
    throw error
  }
}

export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error) throw error
  return user
}

// Create or get user profile
export const getOrCreateProfile = async (userId: string) => {
  const { data: profile, error: fetchError } = await supabase
    .from('profiles')
    .select('*')
    .eq('user_id', userId)
    .single()

  if (fetchError && fetchError.code === 'PGRST116') {
    // Profile doesn't exist, create it
    const { data: newProfile, error: createError } = await supabase
      .from('profiles')
      .insert([{ user_id: userId }])
      .select()
      .single()

    if (createError) throw createError
    return newProfile
  }

  if (fetchError) throw fetchError
  return profile
}

// Update user preferences
export const updateProfile = async (userId: string, updates: Partial<{ quiet_mode: boolean; low_stim_mode: boolean }>) => {
  const { data, error } = await supabase
    .from('profiles')
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq('user_id', userId)
    .select()
    .single()

  if (error) throw error
  return data
}